const variantsExtend = ['responsive', 'hover', 'focus', 'group-hover', 'group-focus', 'odd', 'even']

module.exports = {
  purge: {
    // enabled: true,
    content: [
      "./src/App.vue",
      "./src/components/**/*.vue"
    ],
  },
  theme: {
    extend: {
      width: {
        '960': '60rem',
      },
      maxWidth: {
        'fit': 'fit-content',
      },
      colors: {
        'primary': '#5599ff',
        'navy': '#2E3842'
      },
      fontSize: {
        '2xs': '.688rem',
      },
      cursor: {
        'grab': 'grab',
        'grabbing': 'grabbing',
      }
    },
    groupLevel: 10,
    groupScope: "scope",
    groupVariants: ["hover", "focus"],
  },
  variants: {
    extend: {
      width: variantsExtend,
      translate: variantsExtend,
      backgroundColor: variantsExtend,
      textColor: variantsExtend,
      transitionProperty: variantsExtend,
    },
  },
  plugins: [
    require("tailwindcss-nested-groups"),
  ],
}